import React from 'react'
import {Table} from 'react-bootstrap'
import {IincidentReportColumn, IincidentReportList} from './model'

type IncidentDataTableProps = {
  incidentReportcolumn: IincidentReportColumn[]
  tableData: IincidentReportList[]
}

const IncidentTableData = ({incidentReportcolumn, tableData}: IncidentDataTableProps) => {
  return (
    <div className='mt-4' style={{overflowY: 'auto', maxHeight: '18rem'}}>
      <Table
        striped
        bordered
        hover
        className='mt-4'
        style={{
          borderCollapse: 'separate',
          borderSpacing: '0',
        }}
      >
        <thead>
          <tr style={{backgroundColor: '#343a40', color: '#fff', fontWeight: 'bold'}}>
            {/* <th style={{padding: '10px', border: '1px solid #555'}}>#</th> */}
            {incidentReportcolumn.map(({field, headerText}) => (
              <th key={field} style={{padding: '10px', border: '1px solid #555'}}>
                {headerText}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, index) => (
            <tr key={`${index}-row`} style={{border: '1px solid #ddd'}}>
              {/* <td style={{padding: '10px', border: '1px solid #ddd'}}>{index + 1}</td> */}
              <td style={{padding: '10px', border: '1px solid #ddd'}}>{row.events}</td>
              <td style={{padding: '10px', border: '1px solid #ddd'}}>{row.checkpoints}</td>
              <td style={{padding: '10px', border: '1px solid #ddd'}}>{row.noOfEvents}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}

export default IncidentTableData
